import { createClient } from '@supabase/supabase-js';
import { logger } from '../utils/logger';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  logger.warn('[Supabase] Missing Supabase environment variables');
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      persistSession: true,
      detectSessionInUrl: true
    }
  }
);

/** Used to call Edge Functions from the app (e.g. send-invitation-email after insert). */
export function getSupabaseConfig(): { url: string; anonKey: string } {
  const url = supabaseUrl || '';
  const anonKey = supabaseAnonKey || '';
  // Help catch dev/prod mix-up: in prod, the URL must be your PROD Supabase project (invitation goes to prod Edge Function).
  if (process.env.NODE_ENV === 'production' && url && typeof window !== 'undefined') {
    const ref = url.match(/https:\/\/([^.]+)\.supabase\.co/)?.[1] ?? '';
    if (ref && !sessionStorage.getItem('supabase_ref_checked')) {
      sessionStorage.setItem('supabase_ref_checked', '1');
      console.info('[Supabase] Production app is using project:', ref, '- invitation emails will call this project\'s Edge Function.');
    }
  }
  return { url, anonKey };
}

